import cx from 'classnames';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import CloseIcon from '@mui/icons-material/Close';
import LoyaltyIcon from '@mui/icons-material/Loyalty';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import TextFieldWithClear from 'components/TextFieldWithIcon/TextFieldWithIcon';

const styles = require('./styles.pcss');

type Props = {
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
  bookingNumber?: string;
  bookingValue?: number;
  suggestedPoints?: string;
  amount: string;
  reason: string;
  errorMessage?: string;
  onChangeAmount: (event: any) => void;
  onChangeReason: (event: any) => void;
  onClearAmount: () => void;
  onFocusAmount?: () => void;
  onBlurAmount?: () => void;
};

const CRCRefundConfirmation = (props: Props) => {
  return (
    <Dialog
      maxWidth={'md'}
      fullWidth={true}
      className={cx(styles.dialogBox, styles.confirmationDialog)}
      open={props.open}
      onClose={props.onClose}
    >
      <div className={styles.refundConfDialog}>
        <div className={cx(styles.title, styles.titleFontSizePopupConf)}>
          Refund Booking
          <IconButton
            color="inherit"
            onClick={props.onClose}
            className={cx(styles.closeIcon)}
            aria-label="Close"
            size="large"
          >
            <CloseIcon />
          </IconButton>
        </div>

        <div className={styles.refundDesctiption}>
          Refund CRC points for booking <span>{props.bookingNumber}</span>.
          {' '}Booking value: ${Number(props.bookingValue || 0).toFixed(2)}.
          {' '}Suggested points: {props.suggestedPoints || '0'}.
        </div>

        <div className={styles.confRefundBody}>
          <div className={styles.textContainerRef}>
            <RemoveCircleOutlineIcon color="primary" fontSize="small" />
            {' '}Commercial Rewards Points
          </div>

          <div className={styles.inputWrapper}>
            <TextFieldWithClear
              error={Boolean(props.errorMessage)}
              helperText={props.errorMessage}
              onChange={props.onChangeAmount}
              label="Refund Points"
              variant="outlined"
              margin="normal"
              value={props.amount}
              onClear={props.onClearAmount}
              fullWidth={true}
              startAdornment={false}
              icon={<LoyaltyIcon fontSize={'small'} />}
            />

            <TextField
              label="Refund Reason"
              variant="outlined"
              margin="normal"
              value={props.reason}
              onChange={props.onChangeReason}
              fullWidth={true}
            />
          </div>
        </div>

        <div className={cx(styles.refundConfButtons)}>
          <Button
            className={styles.button}
            color="primary"
            variant="outlined"
            onClick={props.onClose}
          >
            Cancel
          </Button>

          <Button
            className={styles.button}
            variant="contained"
            color="primary"
            onClick={props.onSubmit}
          >
            Refund
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default CRCRefundConfirmation;
